module.exports = {

    // 宝塔
    // 外网面板地址: https://47.94.142.60:31964/d14da1d2
    // 内网面板地址: https://172.28.84.94:31964/d14da1d2
    // 用户名:jjjhdpl3
    // 密码：4a98e19d

    // 新域名
    config: {
        'localStorage_token_name': 'access_token',
        'axios_timeout': 20000, // 请求超时时间20秒
        'axios_baseURL': 'https://super.bird.jmlkj.cn',
        'axios_normalURL': 'https://normal.bird.jmlkj.cn',
        'axios_imgURL': 'https://normal.bird.jmlkj.cn/qiniu/upload',
        'hash_key': 'gcss9csffhhc9z',
        'qnKey': '7KhrRruiqd6r3UM5IfMlKUWbyDCbo14bNw5HDbQ2',


        'proType': '青鸟',

        'h5': 'https://h5bird.v3.jmlkj.cn/#/pages/modeInfo/modeInfo?app_version=1.0.1&platform=pc&port=admin&token=&order_mode_code=',
        // 'service_tag': 'LOCAL',
        'city_tag': 'ONLINE_MAIN' //分城市
    }









    // 大连青鸟代驾原域名已停用
    // config: {
    //     'localStorage_token_name': 'access_token',
    //     'axios_timeout': 20000, // 请求超时时间20秒
    //     'axios_baseURL': 'https://superbird.v3.jiuzhoudaijiaapi.cn',
    //     'axios_normalURL': 'https://normalbird.v3.jiuzhoudaijiaapi.cn',
    //     'axios_imgURL': 'https://normalbird.v3.jiuzhoudaijiaapi.cn/qiniu/upload',
    //     'hash_key': 'gcss9csffhhc9z',
    //     'qnKey': '7KhrRruiqd6r3UM5IfMlKUWbyDCbo14bNw5HDbQ2',


    //     'proType': '青鸟',

    //     'h5': 'https://h5bird.v3.jiuzhoudaijiaapi.cn/#/pages/modeInfo/modeInfo?app_version=1.0.1&platform=pc&port=admin&token=&order_mode_code=',
    //     // 'service_tag': 'LOCAL',
    //     'city_tag': 'ONLINE_MAIN' //分城市
    // }

    // 接口
    // driverbird.v3.jiuzhoudaijiaapi.cn
    // socketbird.v3.jiuzhoudaijiaapi.cn 端口：9507
    // superbird.v3.jiuzhoudaijiaapi.cn
    // consumerbird.v3.jiuzhoudaijiaapi.cn
    // normalbird.v3.jiuzhoudaijiaapi.cn
    // cooperationbird.v3.jiuzhoudaijiaapi.cn
    // 9zbird.v3.jiuzhoudaijiaapi.cn
    // h5bird.v3.jiuzhoudaijiaapi.cn

    // 管理端
    // adminbird.v3.jiuzhoudaijiaapi.cn
    // superadbird.v3.jiuzhoudaijiaapi.cn

    // 文件
    // https://f.v3.jiuzhoudaijiaapi.cn



}


// WEBPACK FOOTER //
// ./src/utils/config.js